import { useFormikContext } from 'formik';
import { Gap } from 'lib/components/styles/layout';
import { SubHeading, ParagraphSmall } from 'lib/components/styles/typography';
import { useAuth } from 'lib/context';
import { checkIfVideoRequestFieldsRequired } from 'lib/utils/automotiveRolePermissionChecks';
import React from 'react';
import { DetailsPreviewRecordFormValues } from '../types';
import { useTheme } from 'styled-components/macro';
import { useTranslation } from 'react-i18next';

export const DetailsPreviewAttributesHeader = () => {
  const { t } = useTranslation();
  const { userData } = useAuth();
  const { colors } = useTheme();
  const { values } = useFormikContext<DetailsPreviewRecordFormValues>();

  const videoRequestFieldsRequired =
    checkIfVideoRequestFieldsRequired(userData);

  const getRequiredAttributesCount = () => {
    let count = 0;
    values?.attributes?.forEach(attribute => {
      if (attribute && attribute.isRequired) {
        count++;
      }
    });

    if (videoRequestFieldsRequired)
      // two fields from video req Details are req
      count += 2;

    return count;
  };

  const totalRequiredAttributes = getRequiredAttributesCount();
  return (
    <Gap justifyContent='space-between' m='0 0 16px 0'>
      <SubHeading>{t('Video Attributes')}</SubHeading>
      <ParagraphSmall color={colors.primary[100]}>
        {totalRequiredAttributes} {t('required')}
      </ParagraphSmall>
    </Gap>
  );
};
